export default {
  availability: {
    availabilityType: 102108, // Availability Type
    allDay: 95371, // All Day
    addCycle: 102072, // Add Cycle
    addDate: 102076, // Add Date
    areYouSureYouWantToDeleteCycle: 102080, // Are you sure you want to delete {cycle}?
    areYouSureYouWantToDeleteAllPreferencesFor: 102081, // Are you sure you want to delete all preferences for {preference}?
    available: 91211, // Available
    availability: 91203, // Availability
    biWeekly: 83096, // Bi-Weekly
    copyAvailabilityToOtherDates: 102075, // Copy availability to other dates
    day: 45827, // Day
    days: 45722, // Days
    deleteCycle: 102065, // Delete Cycle
    deletePreferences: 102066, // Delete Prefereces
    firstDayOfCycle: 101241, // First Day of Cycle
    futureCycle: 102071, // Future Cycle
    futureCycles: 102070, // Future Cycles
    indifferent: 91210, // Indifferent
    notAvailable: 91212, // Not Available
    notSpecified: 102079, // Not Specified
    recurringCycle: 102069, // Recurring Cycle
    singleDay: 102068, // Single Day
    specifyAvailability: 102067, // Specify Availability
    startDate: 45095, // Start date
    theAvailabilityForThisDateIsSetAsPartOf: 102074, // The availability for this date is set as part of recurring cycle
    theAvailabilityIsOverwrittenForThisDate: 102073, // The availability is overwritten for this date
    thisActionWillOverwriteRecurringAvailabilityForTheSpecifiedDate: 102078, // This action will overwrite recurring availability for the specified date range:
    timeRange: 101240, // Time Range
    unavailable: 102101, // Unavailable
    week: 100977, // Week
    weekly: 63180, // Weekly
    youHaveSuccessfullyAddedANewCycle: 102082, // You have successfully added a new cycle!
    youHaveSuccessfullyDeletedYourCycle: 102083, // You have successfully deleted your cycle!
    youHaveSuccessfullyDeletedYourPreferences: 102084, // You have successfully deleted your preferences!
    youHaveSuccessfullyUpdatedYourAvailabilities: 102085, // You have successfully updated your availabilities!
    youHaveSuccessfullyUpdatedYourCycle: 102086, // You have successfully updated your cycle!
    youHaveSuccessfullyUpdatedYourPreferences: 102087, // You have successfully updated your preferences!
    youveSpecifiedAvailabilityFor: 102077, // You’ve specified availability for:
  },
};
